import React from "react";
import { Modal, Button, Descriptions, Divider, Tag } from "antd";
import { STAGES } from "components/common/Constants";
import { getFormalName } from "components/services";
import Loader from "components/common/Loader";

// Confirm Forward Modal
export const ConfirmForwardModal = ({
	visible,
	record,
	nextStage,
	onConfirm,
	onCancel,
}) => (
	<Modal
		title="Confirm Forward Action"
		open={visible}
		onOk={onConfirm}
		onCancel={onCancel}
		okText="Confirm Forward"
		cancelText="Cancel"
		okButtonProps={{ type: "primary" }}
		width={500}
	>
		{record && (
			<div style={{ padding: "16px 0" }}>
				<h4 style={{ marginBottom: "12px", color: "#1890ff" }}>Forwarding Details:</h4>
				<div style={{ background: "#f5f5f5", padding: "16px", borderRadius: "8px" }}>
					<p>
						<strong>Job Card No:</strong> {record.id}
						{record.serial_number ? (
							<span style={{ marginLeft: 8 }}>
								<strong>Serial No:</strong> {record.serial_number}
							</span>
						) : null}
					</p>
					<p>
						<strong>Client:</strong> {record.client}
					</p>
					<p>
						<strong>Current Stage:</strong> {getFormalName(record.current_stage)}
					</p>
					<p>
						<strong>Forward to:</strong>{" "}
						<span style={{ color: "#52c41a", fontWeight: "bold" }}>
							{record.current_stage === STAGES.DISPATCH
								? "Mark as Completed"
								: getFormalName(nextStage)}
						</span>
					</p>
					<p>
						<strong>Quantity:</strong> {record.quantity}
					</p>
					<p>
						<strong>Delivery Date:</strong> {record.deliver_date}
					</p>
				</div>
				<p style={{ marginTop: "16px", color: "#666" }}>
					Are you sure you want to forward this job card?
				</p>
			</div>
		)}
	</Modal>
);

// Digitizer Work Validation Modal
export const DigitizerValidationModal = ({ visible, incompleteVersions, onClose }) => (
	<Modal
		title="Digitizer Work Remaining"
		open={visible}
		onOk={onClose}
		onCancel={onClose}
		okText="OK"
		cancelButtonProps={{ style: { display: "none" } }}
		width={600}
	>
		<div style={{ padding: "16px 0" }}>
			<p style={{ fontSize: "16px", marginBottom: "16px", color: "#333", fontWeight: 500 }}>
				Digitizer's work is remaining for this job card. Please wait until the digitizer
				completes their work before forwarding to embroidary.
			</p>
			{incompleteVersions && incompleteVersions.length > 0 && (
				<div style={{ marginTop: "16px" }}>
					<strong style={{ display: "block", marginBottom: "8px" }}>
						Job Card with remaining digitizer work:
					</strong>
					<ul style={{ margin: 0, paddingLeft: "20px" }}>
						{incompleteVersions.map((version, index) => (
							<li key={index} style={{ marginBottom: "8px", fontSize: "14px" }}>
								<span style={{ fontWeight: 500 }}>#{version.serial_number}</span>
							</li>
						))}
					</ul>
				</div>
			)}
			<p
				style={{ fontSize: "14px", color: "#666", marginTop: "16px", fontStyle: "italic" }}
			>
				Job card must have completed digitizer work before forwarding to embroidary.
			</p>
		</div>
	</Modal>
);

// Courier Mode Validation Modal
export const CourierModeValidationModal = ({ visible, incompleteVersions, onClose }) => (
	<Modal
		title="Courier Mode Required"
		open={visible}
		onOk={onClose}
		onCancel={onClose}
		okText="OK"
		cancelButtonProps={{ style: { display: "none" } }}
		width={600}
	>
		<div style={{ padding: "16px 0" }}>
			<p style={{ fontSize: "16px", marginBottom: "16px", color: "#333", fontWeight: 500 }}>
				Some job card versions do not have courier mode defined. Please define courier mode
				for all versions before forwarding from packing stage.
			</p>
			{incompleteVersions && incompleteVersions.length > 0 && (
				<div style={{ marginTop: "16px" }}>
					<strong style={{ display: "block", marginBottom: "8px" }}>
						Versions with missing courier mode:
					</strong>
					<ul style={{ margin: 0, paddingLeft: "20px" }}>
						{incompleteVersions.map((version, index) => (
							<li key={index} style={{ marginBottom: "8px", fontSize: "14px" }}>
								<span style={{ fontWeight: 500 }}>#{version.serial_number}</span>
							</li>
						))}
					</ul>
				</div>
			)}
			<p
				style={{ fontSize: "14px", color: "#666", marginTop: "16px", fontStyle: "italic" }}
			>
				All versions in a job card group must have courier mode defined before forwarding
				from packing stage.
			</p>
		</div>
	</Modal>
);

// Invoice Validation Modal
export const InvoiceValidationModal = ({ visible, incompleteVersions, onClose }) => (
	<Modal
		title="Invoice Required"
		open={visible}
		onOk={onClose}
		onCancel={onClose}
		okText="OK"
		cancelButtonProps={{ style: { display: "none" } }}
		width={600}
	>
		<div style={{ padding: "16px 0" }}>
			<p style={{ fontSize: "16px", marginBottom: "16px", color: "#333", fontWeight: 500 }}>
				Some job card versions do not have invoices uploaded. Please upload at least one
				invoice for all versions before forwarding from account stage.
			</p>
			{incompleteVersions && incompleteVersions.length > 0 && (
				<div style={{ marginTop: "16px" }}>
					<strong style={{ display: "block", marginBottom: "8px" }}>
						Versions with missing invoices:
					</strong>
					<ul style={{ margin: 0, paddingLeft: "20px" }}>
						{incompleteVersions.map((version, index) => (
							<li key={index} style={{ marginBottom: "8px", fontSize: "14px" }}>
								<span style={{ fontWeight: 500 }}>#{version.serial_number}</span>
							</li>
						))}
					</ul>
				</div>
			)}
			<p
				style={{ fontSize: "14px", color: "#666", marginTop: "16px", fontStyle: "italic" }}
			>
				All versions in a job card group must have at least one invoice uploaded before
				forwarding from account stage.
			</p>
		</div>
	</Modal>
);

// Jobcard Info Modal (for packing/dispatch)
export const JobcardInfoModal = ({
	visible,
	jobcardId,
	jobcardDetail,
	clientsList,
	onClose,
	onOpenFullPage,
}) => (
	<Modal
		title={`Jobcard #${jobcardDetail?.serial_number || jobcardId || ""} - Summary`}
		open={visible}
		onCancel={onClose}
		footer={[
			<Button key="close" onClick={onClose}>
				Close
			</Button>,
			<Button key="open" type="primary" onClick={onOpenFullPage}>
				Open Full Page
			</Button>,
		]}
		width={700}
	>
		{!jobcardDetail ? (
			<Loader />
		) : (
			<div style={{ paddingTop: 8 }}>
				<Descriptions bordered column={1} size="middle">
					<Descriptions.Item label="Client">
						{clientsList?.find((c) => c.id === jobcardDetail.client)?.company_name || "—"}
					</Descriptions.Item>
					<Descriptions.Item label="Quantity">
						{jobcardDetail.quantity ?? "—"}
					</Descriptions.Item>
					<Descriptions.Item label="Delivery Date">
						{jobcardDetail.deliver_date || "—"}
					</Descriptions.Item>
					<Descriptions.Item label="Current Stage">
						<Tag color="blue">{getFormalName(jobcardDetail.current_stage) || "—"}</Tag>
					</Descriptions.Item>
				</Descriptions>

				<Divider />

				<Descriptions title="Dispatch / Packing" bordered column={1} size="middle">
					<Descriptions.Item label="Courier Mode">
						{jobcardDetail.courier_mode || "—"}
						{jobcardDetail.courier_mode === "Courier" && jobcardDetail.courier_name
							? ` — ${jobcardDetail.courier_name}`
							: ""}
					</Descriptions.Item>
					<Descriptions.Item label="Shipping Address">
						{jobcardDetail.shipping_address || "—"}
					</Descriptions.Item>
					<Descriptions.Item label="Carton Boxes">
						{Array.isArray(jobcardDetail.carton_boxes) &&
						jobcardDetail.carton_boxes.length > 0 ? (
							<div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
								{jobcardDetail.carton_boxes.map((box) => (
									<Tag key={`${box.size}-${box.quantity}`} color="geekblue">
										Size {box.size}: {box.quantity}
									</Tag>
								))}
							</div>
						) : (
							"—"
						)}
					</Descriptions.Item>
					<Descriptions.Item label="Packing Note">
						{jobcardDetail.packing_note || "—"}
					</Descriptions.Item>
				</Descriptions>
			</div>
		)}
	</Modal>
);
